import React, { FC } from 'react';
import { useStyleConfig, Box, Flex } from '@chakra-ui/react';
import { Link } from 'react-router-dom';

interface NavItemProps {
  externalLink?: string;
  to?: string;
  children?: React.ReactNode;
  isLast?: boolean;
  variant?: string;
  selected?: boolean;
}

const NavItem: FC<NavItemProps> = (props) => {
  let variant = props.variant ? props.variant : 'default';
  if (props.selected) {
    variant = 'selected';
  }
  const { children, to, externalLink, isLast, ...rest } = props;
  const styles = useStyleConfig('NavItem', { variant });

  let LinkValue;

  if (externalLink) {
    LinkValue = (
      <Flex
        cursor='pointer'
        onClick={() => window.open(externalLink, '_blank')}
        __css={styles}
        {...rest}
      >
        {children}
      </Flex>
    );
  } else if (to) {
    LinkValue = (
      <Box __css={styles} {...rest}>
        <Link to={to}>{children}</Link>
      </Box>
    );
  } else {
    LinkValue = (
      <Box __css={styles} {...rest}>
        {children}
      </Box>
    );
  }

  return LinkValue;
};

export default NavItem;
